import React from 'react';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn
} from 'material-ui/Table';
import StashAppBar from '../components/StashAppBar';
import AvatarEditor from 'react-avatar-editor';
import FlatButton from 'material-ui/FlatButton';
import StashAPI from '../StashAPI';
import noAvatarImg from '../../static/img/no_image_user.png';


const rootStyle = {
  margin: '0 auto',
  maxWidth: 900,
  width: '100%',
};

const lastColumn = {
  width: 80,
};

const titleStyle = {
  color: '#fff',
  margin: 0,
  padding: '10px 0 0 0',
};

const avatarStyle = {
  margin: '20px 0',
  width: '100%',
};

const detailsStyle = {
  margin: '20px 0',
  width: '100%',
};

const editBtnLabelStyle = {
  textTransform: 'lowercase',
  textDecoration: 'underline',
};


export default class UserProfilePage extends React.Component {

  constructor() {
    super();
    this.state = {
      avatar: noAvatarImg,
      userProps: [],
    };
  }

  componentWillMount() {
    (new StashAPI()).getUserDetails().then(response => {
      let props = [];
      for (let prop of response.data) {
        if (prop.meta.slug === 'avatar') {
          this.setState({avatar: prop.value});
        } else {
          props.push(prop);
        }
      }
      this.setState({userProps: props});
    }).catch(error => {
      return Promise.reject(error);
    });
  }

  render() {
    const { userProps, avatar } = this.state;
    return (
      <div>
        <StashAppBar spacer>
          <h1 style={titleStyle}>Personal info & privacy</h1>
        </StashAppBar>
        <div style={rootStyle}>
          <div style={avatarStyle}>
            <h3>Your Stash Avatar</h3>
            <AvatarEditor
              image={avatar}
              width={240}
              height={240}
              border={5}
              color={[200, 200, 200, 0.4]}  // RGBA
              scale={1.2}
              rotate={0}
            />
          </div>
          <div style={detailsStyle}>
            <h3>Your Personal Details</h3>
            <Table>
              <TableBody displayRowCheckbox={false}>
                {userProps.map((item, index) => {
                  return (
                    <TableRow key={item.meta.slug}>
                      <TableRowColumn>
                        <h4>{item.meta.name}</h4>
                      </TableRowColumn>
                      <TableRowColumn>
                        {item.value}
                      </TableRowColumn>
                      <TableRowColumn style={lastColumn}>
                        <FlatButton
                          label="change"
                          labelStyle={editBtnLabelStyle}
                        />
                      </TableRowColumn>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/UserProfilePage.jsx